import { Divider, Menu } from 'antd';
import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { UnsavedChangesModal } from '../AppModal/modals';
import { useUnsaved } from '@/contexts/UnsavedContext';
import PATH from '@/config/paths/PATH';
// import logo from '@/assets/images/side-bar-bg.jpg';
// import { User } from 'lucide-react';
// import useUser from '@/redux/hooks/useUser';
function Sider({ items, theme, hasLogo = false, isMobile = false, handleCloseDrawer, openDrawer }) {
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState([]);
  const { hasUnsaved } = useUnsaved();
  const navigate = useNavigate();
  // const [openKeys, setOpenKeys] = useState([]);
  // const { user } = useUser();

  useEffect(() => {
    const currentPath = location.pathname;
    const { selected } = findActiveMenuKeys(currentPath, items);
    setSelectedKey([selected]);
    // setOpenKeys(open ? [open] : []);
  }, [location, items]);
  const handleMenuClick = (e, target) => {
    if (hasUnsaved) {
      e.preventDefault();
      UnsavedChangesModal(() => {
        navigate(target, { replace: true });
      });
      return false;
    }

    if (openDrawer) {
      handleCloseDrawer();
    }

    return true;
  };

  const findActiveMenuKeys = (path, items) => {
    for (const item of items) {
      if (item.path === path) {
        return { selected: item.key };
      }
      if (item.children) {
        for (const child of item.children) {
          if (child.path === path || path.startsWith(child.path)) {
            return { selected: child.key };
          }
        }
        if (path.startsWith(item.path)) {
          return { selected: item.key };
        }
      } else if (item.path && path.startsWith(item.path)) {
        return { selected: item.key };
      }
    }
    return { selected: '' };
  };

  const menuItems = items.map((item) => ({
    ...item,
    label: item.children ? (
      <span>{item.label}</span>
    ) : (
      <NavLink to={item.path} onClick={(e) => handleMenuClick(e, item.path)}>
        {item.label}
      </NavLink>
    ),
    children: item.children?.map((child) => ({
      ...child,
      label: (
        <NavLink
          to={child.path}
          className={({ isActive, isPending }) =>
            isPending ? 'pending' : isActive ? 'active' : ''
          }
          onClick={(e) => handleMenuClick(e, child.path)}
        >
          {child.label}
        </NavLink>
      ),
    })),
  }));

  return (
    <div className={!isMobile ? 'pb-1' : ''}>
      {hasLogo && (
        <div className="sticky top-0 inset-x-0 bg-white z-[1000]">
          <div className="logo flex items-center justify-center flex-row h-16 p-4">
            <Link to={PATH.REPORT.ROOT}>
              <img src="/logo.png" alt="Magic Wheel" className="aspect-auto w-24 h-auto" />
            </Link>
          </div>
          <Divider className="mx-auto my-0 min-w-[95%] w-[95%]" />
        </div>
      )}
      <Menu
        theme={theme}
        mode="inline"
        selectedKeys={selectedKey}
        // openKeys={openKeys}
        defaultOpenKeys={['report', 'customer-care']}
        items={menuItems}
        // width={250}
      />

      {/* <div className="p-4 px-1 border-t border-gray-200">
        <Button
          type="text"
          danger
          icon={<LogoutOutlined />}
          className="w-full text-left justify-start min-h-[40px] px-6"
          onClick={() => setOpenModal(true)}
        >
          Sign out
        </Button>
        <LogoutModal openModal={openModal} setOpenModal={setOpenModal} />
      </div> */}
    </div>
  );
}

export default Sider;
